const CODE_VERIFIER = 'code_verifier';
const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const EXPIRE_TIME = 'expire_time';
const LAST_ADDED_ALBUM_TIME = 'last_added_album_time';
const DEBUG_DATA = 'debug_data';
const TOO_MANY_REQUESTS_BLOCKING = 'too_many_requests_blocking';

export const loadCodeVerifier = () => loadItem(CODE_VERIFIER);
export const saveCodeVerifier = (value) => saveItem(CODE_VERIFIER, value);
export const clearCodeVerifier = () => clearItem(CODE_VERIFIER);

export const loadAccessToken = () => loadItem(ACCESS_TOKEN);
export const saveAccessToken = (value) => saveItem(ACCESS_TOKEN, value);
export const clearAccessToken = () => clearItem(ACCESS_TOKEN);

export const loadRefreshToken = () => loadItem(REFRESH_TOKEN);
export const saveRefreshToken = (value) => saveItem(REFRESH_TOKEN, value);
export const clearRefreshToken = () => clearItem(REFRESH_TOKEN);

export const loadExpireTime = () => loadItem(EXPIRE_TIME);
export const saveExpireTime = (value) => saveItem(EXPIRE_TIME, value);
export const clearExpireTime = () => clearItem(EXPIRE_TIME);

export const loadLastAddedAlbumTime = () => loadItem(LAST_ADDED_ALBUM_TIME);
export const saveLastAddedAlbumTime = (value) => saveItem(LAST_ADDED_ALBUM_TIME, value);
export const clearLastAddedAlbumTime = () => clearItem(LAST_ADDED_ALBUM_TIME);
export const updateLastAddedAlbumTime = (value) => {
    const currentLastAddedAlbumTime = loadLastAddedAlbumTime();
    
    if(currentLastAddedAlbumTime && currentLastAddedAlbumTime > value)
    {
        return;
    }

    saveLastAddedAlbumTime(value);
}

export const loadDebugData = () => loadItem(DEBUG_DATA);
export const saveDebugData = (value) => saveItem(DEBUG_DATA, value);
export const clearDebugData = () => clearItem(DEBUG_DATA);

export const loadTooManyRequestsBlocking = () => loadItem(TOO_MANY_REQUESTS_BLOCKING) && loadItem(TOO_MANY_REQUESTS_BLOCKING).toLowerCase() === 'true';
export const saveTooManyRequestsBlocking = (value) => saveItem(TOO_MANY_REQUESTS_BLOCKING, value);
export const clearTooManyRequestsBlocking = () => clearItem(TOO_MANY_REQUESTS_BLOCKING);

// #region User config params

const DETAILED_ALBUM_LIST_PAGE_SIZE = 'detailed_album_list_page_size';
const SQUARED_ALBUM_LIST_PAGE_SIZE = 'squared_album_list_page_size';
const RANDOM_METHOD = 'random_method';
const RANDOM_QUEUE_LIMIT = 'random_queue_limit';
const AUTO_NEW_RANDOM_ALBUM = 'auto_new_random_album';
const ALWAYS_CLEAR_QUEUE = 'always_clear_queue';
const ACTION_FOR_STARTING_RANDOM_MODE = 'action_for_starting_random_mode';
const ACTION_FOR_RESUMING_RANDOM_MODE = 'action_for_resuming_random_mode';

export const loadDetailedAlbumListPageSize = () => loadItem(DETAILED_ALBUM_LIST_PAGE_SIZE);
export const saveDetailedAlbumListPageSize = (value) => saveItem(DETAILED_ALBUM_LIST_PAGE_SIZE, value);
export const clearDetailedAlbumListPageSize = () => clearItem(DETAILED_ALBUM_LIST_PAGE_SIZE);

export const loadSquaredAlbumListPageSize = () => loadItem(SQUARED_ALBUM_LIST_PAGE_SIZE);
export const saveSquaredAlbumListPageSize = (value) => saveItem(SQUARED_ALBUM_LIST_PAGE_SIZE, value);
export const clearSquaredAlbumListPageSize = () => clearItem(SQUARED_ALBUM_LIST_PAGE_SIZE);

export const loadRandomMethod = () => loadItem(RANDOM_METHOD);
export const saveRandomMethod = (value) => saveItem(RANDOM_METHOD, value);
export const clearRandomMethod = () => clearItem(RANDOM_METHOD);

export const loadRandomQueueLimit = () => loadItem(RANDOM_QUEUE_LIMIT);
export const saveRandomQueueLimit = (value) => saveItem(RANDOM_QUEUE_LIMIT, value);
export const clearRandomQueueLimit = () => clearItem(RANDOM_QUEUE_LIMIT);

export const loadAutoNewRandomAlbum = () => loadItem(AUTO_NEW_RANDOM_ALBUM) && loadItem(AUTO_NEW_RANDOM_ALBUM).toLowerCase() === 'true';
export const saveAutoNewRandomAlbum = (value) => saveItem(AUTO_NEW_RANDOM_ALBUM, value);
export const clearAutoNewRandomAlbum = () => clearItem(AUTO_NEW_RANDOM_ALBUM);

export const loadAlwaysClearQueue = () => loadItem(ALWAYS_CLEAR_QUEUE) && loadItem(ALWAYS_CLEAR_QUEUE).toLowerCase() === 'true';
export const saveAlwaysClearQueue = (value) => saveItem(ALWAYS_CLEAR_QUEUE, value);
export const clearAlwaysClearQueue = () => clearItem(ALWAYS_CLEAR_QUEUE);

export const loadActionForStartingRandomMode = () => loadItem(ACTION_FOR_STARTING_RANDOM_MODE);
export const saveActionForStartingRandomMode = (value) => saveItem(ACTION_FOR_STARTING_RANDOM_MODE, value);
export const clearActionForStartingRandomMode = () => clearItem(ACTION_FOR_STARTING_RANDOM_MODE);

export const loadActionForResumingRandomMode = () => loadItem(ACTION_FOR_RESUMING_RANDOM_MODE);
export const saveActionForResumingRandomMode = (value) => saveItem(ACTION_FOR_RESUMING_RANDOM_MODE, value);
export const clearActionForResumingRandomMode = () => clearItem(ACTION_FOR_RESUMING_RANDOM_MODE);

// #endregion

const loadItem = (itemId) => localStorage.getItem(itemId);
const saveItem = (itemId, value) => localStorage.setItem(itemId, value);
const clearItem = (itemId) => localStorage.removeItem(itemId);